import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import { getJobRelatedExpenseFieldsYupOnSaveSchema } from "entities/JobRelatedExpense";
import i18n from "shared/i18n";
import * as yup from "yup";

const parseDateString = (value) => {
  const formatted = dayjs(value);
  return formatted.isValid() ? formatted.format("YYYY-MM-DD") : null;
};

export function getOnSaveValidationSchema(filesValidationSchema) {
  const jobRelatedExpenseSchema = getJobRelatedExpenseFieldsYupOnSaveSchema();
  return yupResolver(
    yup.object().shape({
      ...jobRelatedExpenseSchema,
      invoice_number: yup
        .string()
        .when("is_job_related", (isJobRelated, schema) =>
          isJobRelated
            ? schema.max(
                20,
                i18n.t("validations.invoice_number.max", {
                  ns: "CostLine",
                })
              )
            : schema.notRequired()
        ),
      amount: yup
        .number()
        .notRequired()
        .nullable()
        .when("cost_type", {
          is: (costType) => costType?.value.subtype === "Mileage",
          then: (schema) => schema,
          otherwise: (schema) =>
            schema.positive(
              i18n.t("validations.amount.greater_than_zero", {
                ns: "CostLine",
              })
            ),
        }),
      purchase_date: yup.string().transform(parseDateString).nullable(),
      distance: yup.string().nullable(),
      vehicle_id: yup
        .mixed()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      attachments: filesValidationSchema,
    })
  );
}
